export const TC_ID_UPDATED = "TC_ID_UPDATED";
export const TC_UTC_UPDATED = "TC_UTC_UPDATED";
export const TC_URATE_UPDATED = "TC_URATE_UPDATED";
export const TC_CRATE_UPDATED = "TC_CRATE_UPDATED";
export const TC_UCRATE_UPDATED = "TC_UCRATE_UPDATED";
export const TC_UPDATED = "TC_UPDATED";
export const TC_INVALIDATED = "TC_INVALIDATED";

export const TC_UNSAVED_ADD = "TC_UNSAVED_ADD";
export const TC_UNSAVED_DELETE = "TC_UNSAVED_DELETE";
export const TC_UNSAVED_CLEAR = "TC_UNSAVED_CLEAR";